import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getEvents } from "../Service/Api";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import LazyLoad from "react-lazyload";
const HomeEvent = () => {
  const {
    data: events = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["events"],
    queryFn: async () => {
      const datas1 = await getEvents();
      return datas1;
    },
  });
  var settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      { breakpoint: 1300, settings: { slidesToShow: 3 } },
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 767, settings: { slidesToShow: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } },
    ],
  };

  const emptyArray = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }];

  function formatDateToDDMMYYYY(dateInput) {
    const date = new Date(dateInput);
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  }

  // ✅ Loading & Error handling
  if (isLoading) {
    return (
      <div className="row">
        <div className="eventbg text-center py-5">
          <p>Loading events...</p>
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="row">
        <div className="eventbg text-center py-5">
          <p>Failed to load events.</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="row">
        <div className="eventbg">
          <Slider {...settings}>
            {events.length > 0
              ? events.map((item) => (
                <div className="item" key={item._id}>
                  <div className="homeeventbox">
                    <div className="homeeventboximg">
                      <LazyLoad>
                        {item.images && item.images.length > 0 ? (
                          <img
                            src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.images[0]}`}
                            className="img-fluid"
                            alt={item.title}
                          />
                        ) : (
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/events.jpg"
                            className="img-fluid"
                            alt="Frank Anthony Bangalore"
                          />
                        )}
                      </LazyLoad>
                    </div>
                    <div className="homeeventboxdesc">
                      <div className="homeeventboxbottom">
                        <span>{formatDateToDDMMYYYY(item.date)}</span>
                      </div>

                      <div className="homeeventboxtitle">
                        <p>{item.title}</p>
                        <p>
                          <span>
                            <LazyLoad>
                              <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/location.gif"
                                className="img-fluid"
                                alt="location"
                              />
                            </LazyLoad>
                            {item.venue}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))
              : emptyArray.map((data) => (
                <div className="item" key={data.id}>
                  <div className="homeeventbox">
                    <div className="homeeventboximg">
                      <LazyLoad>
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/events.jpg"
                          className="img-fluid"
                          alt="Frank Anthony Bangalore"
                        />
                      </LazyLoad>
                    </div>
                    <div className="homeeventboxdesc">
                      <div className="homeeventboxbottom">
                        <span>DD-MM-YYYY</span>
                      </div>
                      <div className="homeeventboxtitle">
                        <p>Title</p>
                        <p>
                          <span>
                            <LazyLoad>
                              <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/location.gif"
                                className="img-fluid"
                                alt="Frank Anthony Bangalore"
                              />
                            </LazyLoad>
                            School Campus
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </Slider>
        </div>
      </div>
    </>
  );
};

export default HomeEvent;
